<div class="layers-panel">
  <div class="ortho-body">
    <div class="panel-header">
      <img [src]="icon()" alt="" />
      <span class="title">{{ title() }}</span>
    </div>

    @if (canManage) {
      <div class="ortho-add-section">
        <button type="button" class="btn-add-ortho" (click)="add()">
          <i class="fas fa-plus"></i>
          {{ 'GLOBAL.AJOUTER' | translate }}
        </button>
      </div>
    }

    @if (rows().length > 0) {
      <div class="ortho-list" cdkDropList #list="cdkDropList" (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="kind() !== 'orthophotos'">
        @for (row of rows(); track row.key) {
          <div class="ortho-card" cdkDrag [cdkDragDisabled]="kind() !== 'orthophotos'" [cdkDragBoundary]="list.element" [class.active]="row.visible">
            @if (kind() === 'orthophotos') {
              <div class="order-indicator">
                <button
                  type="button"
                  class="arrow up"
                  (mousedown)="$event.stopPropagation()"
                  (touchstart)="$event.stopPropagation()"
                  (click)="move(row.key, -1)"
                  [disabled]="row.zOrder === 1"
                  aria-label="Monter"></button>
                <span class="idx">{{ row.zOrder }}</span>
                <button
                  type="button"
                  class="arrow down"
                  (mousedown)="$event.stopPropagation()"
                  (touchstart)="$event.stopPropagation()"
                  (click)="move(row.key, 1)"
                  [disabled]="row.zOrder === rows().length"
                  aria-label="Descendre"></button>
              </div>
            }

            <div class="ortho-content" cdkDragHandle [class.visible]="row.visible">
              <div class="ortho-preview">
                <img [src]="icon()" [alt]="row.name" />
              </div>
              <div class="ortho-name" [title]="row.name">{{ row.name }}</div>
              <div class="ortho-info">
                @if (row.date) {
                  <p class="ortho-date">{{ row.date | date: 'dd/MM/yyyy' }}</p>
                }
              </div>

              @if (kind() === 'orthophotos' && canManage) {
                <div class="delete-ortho" title="Supprimer cette couche" (click)="askDelete(row.key)">
                  <img src="assets/icon/delete.svg" alt="Supprimer" />
                </div>
              }

              <div class="visibility-toggle">
                <label class="checkbox">
                  <input type="checkbox" [checked]="row.visible" [attr.aria-label]="row.name" (change)="toggle(row.key)" />
                  <span></span>
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="ortho-empty">
        <p class="ortho-empty-title">{{ emptyKey() | translate }}</p>
      </div>
    }
  </div>
</div>

<app-popup
  [isOpen]="orthophotoToDelete() !== null"
  [title]="'GLOBAL.SUPPRIMER' | translate"
  size="xsmall"
  variant="secondary"
  color="amarante"
  (closed)="cancelDelete()">
  <p>{{ 'GLOBAL.CONFIRMATION_SUPPRESSION' | translate }}</p>
  @if (orthophotoToDelete(); as orthophoto) {
    <p class="delete-name">{{ orthophoto.mapName }}</p>
  }
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.NON' | translate" (clicked)="cancelDelete()" />
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.OUI' | translate" (clicked)="confirmDelete()" />
  </ng-container>
</app-popup>
